var levelOfAWSUsage = {
	"Level of AWS usage": "Tingkat Penggunaan AWS",
	"Do not use AWS today": "Jangan gunakan AWS hari ini",
	"Evaluating/experimenting with AWS": "Mengevaluasi/bereksperimen dengan AWS",
	"Run dev/test workloads on AWS": "Jalankan beban kerja pengembangan/uji pada AWS",
	"Run a production workload on AWS": "Jalankan beban produksi tunggal pada AWS",
	"Run multiple production workloads on AWS": "Jalankan beberapa beban kerja produksi pada AWS"
};

export { levelOfAWSUsage as default };
